// One value rather than two booleans, so NO_SIGNAL suppressing DONE is structural: flashing
// Done when nothing was captured invites the rep to submit an empty recording.
enum ChatVoiceHint {
  DONE = "done",
  NONE = "none",
  NO_SIGNAL = "noSignal",
}

export default ChatVoiceHint;
